import React from "react";

// A prominent subsection header used to visually separate groups of fields
// within a form/tab (distinct from a plain field label). Reusable via
// FormItemType.sectionHeader.
export const SectionHeader = (props) => {
  const { field: bb, editTableProps, rowIdentity, watch } = props;
  const hide = bb.hideIf ? bb.hideIf({ editTableProps, rowIdentity, watch }) : false;
  if (hide) return null;

  return (
    <div
      style={{
        width: "100%",
        marginTop: "1.25rem",
        marginBottom: "0.75rem",
        paddingBottom: "0.35rem",
        borderBottom: "2px solid #0072ce",
        fontSize: "0.95rem",
        fontWeight: 700,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
        color: "#0072ce",
        ...bb.style,
      }}
    >
      {bb.label}
    </div>
  );
};
